<template>
  <nav class="bg-primary-500">
    <div class="px-4 mx-auto sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16">
        <div class="flex items-center">
          <div class="cflex-shrink-0 logo">
            <img
              class="content-center h-12 mx-auto"
              src="@/assets/img/hippocast_logo_bluebg.png"
              alt="Workflow logo"
            />
          </div>
        </div>
        <div class="hidden md:block">
          <div class="flex items-baseline ml-10">
            <router-link
              class="px-3 py-2 text-sm font-medium rounded-md text-light bg-primary-900 focus:outline-none focus:text-light focus:bg-primary-600"
              to="/studio/projects"
              >Projects</router-link
            >

            <router-link
              to="/studio/templates"
              class="px-3 py-2 ml-4 text-sm font-medium rounded-md text-light hover:text-light hover:bg-primary-600 focus:outline-none focus:text-light focus:bg-primary-600"
              >Templates</router-link
            >

            <a
              href="#"
              class="px-3 py-2 ml-4 text-sm font-medium rounded-md text-light hover:text-light hover:bg-primary-600 focus:outline-none focus:text-light focus:bg-primary-600"
              >Planner</a
            >
            <a
              href="#"
              class="px-3 py-2 ml-4 text-sm font-medium rounded-md text-light hover:text-light hover:bg-primary-600 focus:outline-none focus:text-light focus:bg-primary-600"
              >Team</a
            >
            <span v-if="!$auth.loading">
              <!-- show login when not authenticated -->
              <a
                v-if="!$auth.isAuthenticated"
                @click="login"
                class="px-3 py-2 ml-4 text-sm font-medium rounded-md text-light hover:text-light hover:bg-primary-600 focus:outline-none focus:text-light focus:bg-primary-600"
              >
                Log in
              </a>
              <!-- show logout when authenticated -->
              <a
                class="px-3 py-2 ml-4 text-sm font-medium rounded-md text-light hover:text-light hover:bg-primary-600 focus:outline-none focus:text-light focus:bg-primary-600"
                v-if="$auth.isAuthenticated"
                @click="logout"
              >
                Log out
              </a>

              <a
                class="px-3 py-2 ml-4 text-sm font-medium rounded-md text-light hover:text-light hover:bg-primary-600 focus:outline-none focus:text-light focus:bg-primary-600"
                @click="testHttp"
              >
                test http
              </a>
            </span>
          </div>
        </div>
        <div class="hidden md:block">
          <div
            class="flex items-center ml-4 md:ml-6"
            v-if="$auth.isAuthenticated"
          >
            <button
              class="p-1 border-2 border-transparent rounded-full text-light hover:text-secondary-500 focus:outline-none focus:text-light focus:bg-primary-600"
              aria-label="Notifications"
            >
              <svg
                class="w-6 h-6"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                />
              </svg>
            </button>

            <!-- Profile dropdown -->
            <div class="relative ml-3">
              <div>
                <button
                  class="flex items-center max-w-xs text-sm rounded-full text-light focus:outline-none focus:shadow-solid"
                  id="user-menu"
                  aria-label="User menu"
                  aria-haspopup="true"
                  @click="userMenuOpen = !userMenuOpen"
                >
                  <img
                    class="w-8 h-8 rounded-full"
                    :src="$auth.user.picture"
                    alt
                  />
                </button>
              </div>
              <!--
                Profile dropdown panel, show/hide based on dropdown state.

                Entering: "transition ease-out duration-100"
                  From: "transform opacity-0 scale-95"
                  To: "transform opacity-100 scale-100"
                Leaving: "transition ease-in duration-75"
                  From: "transform opacity-100 scale-100"
                  To: "transform opacity-0 scale-95"
              -->
              <div
                class="absolute right-0 z-10 w-48 mt-2 origin-top-right rounded-md shadow-lg"
                v-show="userMenuOpen"
              >
                <div class="py-1 rounded-md shadow-xs bg-light">
                  <div v-if="$auth.isAuthenticated">
                    <div>
                      <h2>{{ $auth.user.name }}</h2>
                      <p>{{ $auth.user.email }}</p>
                    </div>

                    <div class="text-xs">
                      <pre>{{ JSON.stringify($auth.user, null, 2) }}</pre>
                    </div>
                  </div>
                  <a
                    href="#"
                    class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >Your Profile</a
                  >
                  <a
                    href="#"
                    class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >Settings</a
                  >
                  <a
                    href="#"
                    class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >Sign out</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex items-center ml-4 text-white md:ml-6"
            v-else
            @click="login"
          >
            Login
          </div>
        </div>

        <div class="flex -mr-2 md:hidden">
          <!-- Mobile menu button -->
          <button
            class="inline-flex items-center justify-center p-2 rounded-md text-primary-300 hover:text-light hover:bg-primary-600 focus:outline-none focus:bg-primary-600 focus:text-light"
          >
            <!-- Menu open: "hidden", Menu closed: "block" -->
            <svg
              class="block w-6 h-6"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
            <!-- Menu open: "block", Menu closed: "hidden" -->
            <svg
              class="hidden w-6 h-6"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!--
      Mobile menu, toggle classes based on menu state.

      Open: "block", closed: "hidden"
    -->
    <div class="hidden md:hidden">
      <div class="px-2 pt-2 pb-3 sm:px-3">
        <a
          href="#"
          class="block px-3 py-2 text-base font-medium rounded-md text-light bg-primary-800 focus:outline-none focus:text-light focus:bg-gray-700"
          >Studio</a
        >
        <a
          href="#"
          class="block px-3 py-2 mt-1 text-base font-medium rounded-md text-light hover:text-light hover:bg-primary-600 focus:outline-none focus:text-light focus:bg-primary-600"
          >Team</a
        >
        <a
          href="#"
          class="block px-3 py-2 mt-1 text-base font-medium rounded-md text-light hover:text-light hover:bg-primary-600 focus:outline-none focus:text-light focus:bg-primary-600"
          >Projects</a
        >
        <a
          href="#"
          class="block px-3 py-2 mt-1 text-base font-medium rounded-md text-light hover:text-light hover:bg-primary-600 focus:outline-none focus:text-light focus:bg-primary-600"
          >Calendar</a
        >
        <a
          href="#"
          class="block px-3 py-2 mt-1 text-base font-medium rounded-md text-light hover:text-light hover:bg-primary-600 focus:outline-none focus:text-light focus:bg-primary-600"
          >Reports</a
        >
      </div>
      <div class="pt-4 pb-3 border-t border-gray-700">
        <div class="flex items-center px-5">
          <div class="flex-shrink-0">
            <img
              class="w-10 h-10 rounded-full"
              src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
              alt
            />
          </div>
          <div class="ml-3">
            <div class="text-base font-medium leading-none text-light">
              Tom Cook
            </div>
            <div class="mt-1 text-sm font-medium leading-none text-primary-300">
              tom@example.com
            </div>
          </div>
        </div>
        <div
          class="px-2 mt-3"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="user-menu"
        >
          <a
            href="#"
            class="block px-3 py-2 text-base font-medium rounded-md text-primary-300 hover:text-light hover:bg-primary-600 focus:outline-none focus:text-light focus:bg-primary-600"
            role="menuitem"
            >Your Profile</a
          >
          <a
            href="#"
            class="block px-3 py-2 mt-1 text-base font-medium rounded-md text-primary-300 hover:text-light hover:bg-primary-600 focus:outline-none focus:text-light focus:bg-primary-600"
            role="menuitem"
            >Settings</a
          >
          <a
            href="#"
            class="block px-3 py-2 mt-1 text-base font-medium rounded-md text-primary-300 hover:text-light hover:bg-primary-600 focus:outline-none focus:text-light focus:bg-primary-600"
            role="menuitem"
            >Sign out</a
          >
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      userMenuOpen: false,
      isSignedIn: false,
      isInit: false,
      imgUrl: null
    };
  },
  methods: {
    toggleMenu: () => {},
    getAuthCode() {
      // this.$gAuth
      //   .getAuthCode()
      //   .then(authCode => {
      //     //on success
      //     console.log("authCode", authCode);
      //   })
      //   .catch(error => {
      //     //on fail do something
      //     console.error(error);
      //   });
    },
    login() {
      this.$auth.loginWithRedirect();
    },
    // Log the user out
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    },
    testHttp: function() {
      // this.$auth.getTokenSilently().then(token => console.log(token));
      this.$http.get("/channels").then(response => {
        console.log(response);
      });
    }
  }
};
</script>
